<template>
  <fieldset>
    <div class="form-group">
      <label
        for="listing[use_custom_features]"
        class="sr-only"
      >
        Use custom features?
      </label>
      <select
        id="listing[use_custom_features]"
        name="use_custom_features"
        class="custom-select"
        v-model="useCustomFeatures"
      >
        <option :value="0">Just use the features in the MLS</option>
        <option :value="1">Let me write a custom list of features</option>
      </select>
    </div>
    <div
      v-if="useCustomFeatures"
      class="form-group"
    >
      <div
        v-for="(feature, i) in features"
        class="media mb-3"
      >
        <div class="media-body">
          <input
            class="form-control"
            type="text"
            value=""
            name="custom_features[]"
            v-model="features[i]"
          >
        </div>
        <div class="media-right">
          <button
            class="btn btn-link"
            title="Remove this feature from the list"
            @click.prevent="removeFeature(i)"
          >
            <i class="fa fa-fw fa-minus"></i>
          </button>
        </div>
      </div>
      <button
        class="btn btn-white"
        @click.prevent="addFeature"
      >
        <i class="fa fa-fw fa-plus mr-1"></i>
        Add Feature
      </button>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    let features = this.value.custom_features
    if (!features || features.length < 1) {
      features = ['']
    }
    return {
      useCustomFeatures: !!this.value.use_custom_features ? 1 : 0,
      features,
    }
  },
  methods: {
    addFeature () {
      this.features.push('')
    },
    removeFeature (i) {
      this.features.splice(i, 1)
    }
  }
}
</script>